import { environment } from '@env';

import { UploadDocumentV2Request } from '@/types/document';

export interface UploadDocumentV2FileRequest {
  file: File;
  data_type?: string;
  location_ids?: number[];
  tags?: {
    property_location_ids?: number[];
    building_ids?: number[];
    unit_ids?: number[];
    tenant_ids?: number[];
    property_manager_ids?: number[];
  };
}

export class DocumentService {
  private readonly apiUrl: string;

  constructor() {
    this.apiUrl = `${environment.direct}/document`;
  }

  async uploadDocumentV2Stream(
    request: UploadDocumentV2Request | UploadDocumentV2FileRequest,
    accessToken: string,
    signal?: AbortSignal
  ): Promise<Response> {
    if ('file' in request) {
      // File upload request
      const formData = new FormData();
      formData.append('file', request.file);

      if (request.data_type) {
        formData.append('data_type', request.data_type);
      }

      if (request.location_ids) {
        formData.append('location_ids', JSON.stringify(request.location_ids));
      }

      if (request.tags) {
        formData.append('tags', JSON.stringify(request.tags));
      }

      return fetch(`${this.apiUrl}/v2/upload-stream`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
        signal,
      });
    }

    return fetch(`${this.apiUrl}/v2/upload-stream`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
      signal,
    });
  }
}

export const documentService = new DocumentService();
